import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import type { UserWithRoles } from '@portal/api-models';
import type { ConfigState } from '@portal/store/src/types';

import { selectConfig } from '../../resources/config/selects';
import type { ApplicationState } from '../../store';

export type TrackerPayload = {
  config: ConfigState;
  engineUser: UserWithRoles;
  roles: string[];
};

export const useTracker = (callback: (payload: TrackerPayload) => void) => {
  const hasExecutedRef = useRef(false);

  const { engineUser, roles } = useSelector(
    (state: ApplicationState) => state.user
  );

  const config = useSelector(selectConfig);

  useEffect(() => {
    if (hasExecutedRef.current || !engineUser || !roles) {
      return;
    }

    callback({ config, engineUser, roles });
    hasExecutedRef.current = true;
  }, [callback, config, engineUser, roles]);
};
